export const PRODUCTS_PER_PAGE = 10;

export const SORTING_CRITERIA = {
  QUANTITY: "QUANTITY",
  UNIT_PRICE: "PRICE",
  TOTAL_PRICE: "TOTAL_PRICE",
  NAME: "NAME",
  PRESENTATION: "PRESENTATION",
  PRICE_GROUP: "PRICE_GROUP",
};

export const priceSortingCriteria = [
  SORTING_CRITERIA.UNIT_PRICE,
  SORTING_CRITERIA.TOTAL_PRICE,
  SORTING_CRITERIA.PRICE_GROUP,
];

// Custom Product
export const MAX_CUSTOM_PRODUCT_INPUT_LENGTH = 255;
export const MAX_CUSTOM_PRODUCT_LONG_INPUTP_LENGTH = 255;
export const MAX_CUSTOM_PRODUCT_NUMBER_INPUT_LENGTH = 7;
export const MAX_CUSTOM_PRODUCT_TEXT_AREA_LENGTH = 30000;

export const WITHOUT_ACCESSORY_VALUE = "without";
